import { TextBadge } from 'components/Badge/TextBadge';
import { SearchFilterAccordionItem } from 'modules/search/components/Filters/AccordionItem/SearchFilterAccordionItem';
import { SearchFilterDropdown } from 'modules/search/components/Filters/Dropdown/SearchFilterDropdown';
import { SearchFilterCheckboxFacetOptions } from 'modules/search/components/Filters/FacetOptions/SearchFilterCheckboxFacetOptions';
import { useSearchFacetSelectedValues } from 'modules/search/hooks/filters/useSearchFacetSelectedValues';
import { SearchFilterVariant } from 'modules/search/types/SearchFilterVariant';
import { ORG_TYPE_CHECKBOX_OPTIONS } from 'utils/constants/general/orgTypes';

type Props = {
  variant?: SearchFilterVariant;
};
export function OrgTypeFilter({ variant = 'dropdown' }: Props) {
  // @ts-expect-error Fix Type
  const selectedFilterValues = useSearchFacetSelectedValues('orgType');

  const FilterVariant =
    variant === 'accordion' ? SearchFilterAccordionItem : SearchFilterDropdown;

  return (
    <FilterVariant
      facetType="orgType"
      icon="building"
      label={
        <>
          {getText('Posted By')}{' '}
          <TextBadge content={selectedFilterValues.length} />
        </>
      }
    >
      <SearchFilterCheckboxFacetOptions
        facetType="orgType"
        initialValue={selectedFilterValues}
        options={ORG_TYPE_CHECKBOX_OPTIONS()}
      />
    </FilterVariant>
  );
}
